export default {
    apiKey: "AIzaSyA8P7xnI7F9z84xNhe9bYFEyCQVVMqRLoY",
    authDomain: "bg-tennis.firebaseapp.com",
    databaseURL: "https://bg-tennis.firebaseio.com",
    projectId: "bg-tennis",
    storageBucket: "bg-tennis.appspot.com",
    messagingSenderId: "122875375863",
    appId: "1:122875375863:web:86ec06b53b894c010f63f2",
    measurementId: "G-0TKKZPWW6Z"
};